// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MathUtils } from '../MathUtils';
export class _PriceFormatter {
    constructor() {
        this._numberFormatters = new Map();
        this._numberFormattersWithoutZeroes = new Map();
    }
    getNumberFormatter(point) {
        if (!this._numberFormatters.has(point)) {
            const numberFormatter = new Intl.NumberFormat(undefined, {
                minimumFractionDigits: point,
                maximumFractionDigits: point
            });
            this._numberFormatters.set(point, numberFormatter);
        }
        return this._numberFormatters.get(point);
    }
    getNumberFormatWithoutZeroes(point) {
        if (!this._numberFormattersWithoutZeroes.has(point)) {
            const numberFormatter = new Intl.NumberFormat(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: point
            });
            this._numberFormattersWithoutZeroes.set(point, numberFormatter);
        }
        return this._numberFormattersWithoutZeroes.get(point);
    }
    formatPrice(price, point, withRounding = undefined) {
        if (isNaN(price)) {
            price = 0;
        }
        if (!withRounding) {
            price = MathUtils.TruncateDouble(price, point);
        }
        const formatter = this.getNumberFormatter(point);
        return formatter.format(price);
    }
    formatPriceWithoutZeroes(price, point, withRounding = undefined) {
        if (isNaN(price)) {
            price = 0;
        }
        if (!withRounding) {
            price = MathUtils.TruncateDouble(price, point);
        }
        const formatter = this.getNumberFormatWithoutZeroes(point);
        return formatter.format(price);
    }
    /**
     * Formats a number using its actual decimal precision.
     *
     * @param value - Number to format.
     * @returns Formatted string.
     */
    formatNumberWithPrecision(value) {
        const precision = MathUtils.getValuePrecision(value);
        return value.toFixed(precision);
    }
}
export const PriceFormatter = new _PriceFormatter();
